import { useContext } from 'react'

import { GeneralInfoFormContext } from './general-info-context'

export function useGeneralInfoForm() {
  const ctx = useContext(GeneralInfoFormContext)
  if (!ctx) {
    throw new Error(
      'useGeneralInfoForm must be used within GeneralInfoFormProvider'
    )
  }
  return ctx
}
